import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';

import FormEmailCheckbox from './FormEmailCheckbox';
import FormSelectAll from '../FormSelectAll';

import './index.scss';

type Props = {
  selector: string;
};

function EmailsSelection({ selector }: Props) {
  return (
    <div className="EmailsSelection">
      <div className="d-flex justify-content-end mb-2">
        <Field name={selector} component={FormSelectAll} />
      </div>
      <div className="EmailsSelection__content p-3">
        <FieldArray name={selector}>
          {({ fields }) =>
            fields.length ? (
              fields.map((name, index) => (
                <Field key={`${name}-${fields.value[index].email}`} name={name} component={FormEmailCheckbox} />
              ))
            ) : (
              <div className="EmailsSelection__empty-area p-3 text-center">No Emails to invite</div>
            )
          }
        </FieldArray>
      </div>
    </div>
  );
}

export default EmailsSelection;
